import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";

export default function ControlOverview() {
  const [show, setShow] = useState(false);
  return (
    <>
      <button
        className="btn btn-sm btn-secondary fw-bold text-white rounded-3"
        onClick={() => setShow(true)}
      >
        Details
      </button>
      <Offcanvas show={show} placement="end" onHide={() => setShow(false)}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Controls Overview</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 my-3">
            <div className="fw-bold">Controls Overview </div>
            <div className="my-2">
              <span>Message credit allowance: </span>
              <span className="fw-bold ms-1">150</span>
            </div>
            <div className="my-2">
              <span>Duration: </span>
              <span className="fw-bold ms-1">30 mins</span>
            </div>
            <div className="my-2">
              <span>Max users: </span>
              <span className="fw-bold ms-1">20</span>
            </div>
            <div className="my-2">
              <span>
                Access to messaging destinations (Local / international
                messaging):
              </span>
              <span className="fw-bold ms-1">50</span>
            </div>
            <div className="my-2">
              <span>Inbound numbers quantity per country :</span>
              <span className="fw-bold ms-1">10</span>
            </div>
            <div className="my-2">
              <span> Number of API connections:</span>
              <span className="fw-bold ms-1">10</span>
            </div>
            <div className="my-2">
              <span>Inbound numbers quantity per country :</span>
              <span className="fw-bold ms-1">5</span>
            </div>
            <div>
              Additional controls will be defined for the different trial types
              as required.
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
